<template>
<div class="chapter">
<div class="inner_page">
<p class="center3" style="margin-top:8em;"><span><img alt="image" height="205" src="images/eye.jpg" width="316"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface003.vue?7064e0e7